// doesn't work in gatsby develop when we accessed like process.env['GATSBY_ENV'] so we need to write it fully process.env.GATSBY_ENV
const env = process.env.GATSBY_ENV || process.env.NODE_ENV!;

export const ENV_VARS = {
  app: process.env.APP,
  env,
  previewTargetOrigin: process.env.PREVIEW_TARGET_ORIGIN,
} as const;
